import { Button, Popconfirm, Space, Table } from "antd";
import React from "react";
import { useNavigate } from "react-router";
import ProjectStore, {
  ProjectInfo,
} from "../../../../stores/Admin/ProjectStore";
import AuthStore from "../../../../stores/AuthStore";
export interface ApplicationsProps {
  projectId: number;
  project: ProjectInfo;
  onEdit: (appId: number) => void;
  onDescribe: (appId: number) => void;
}

const Applications: React.FC<ApplicationsProps> = (props) => {
  const { projects } = ProjectStore;
  const apps = projects?.find(
    (project) => project.id === props.projectId
  )?.refUrlAppVoList;

  const navigate = useNavigate();

  return (
    <div>
      <Table
        bordered={true}
        dataSource={apps}
        rowKey={"name"}
        pagination={false}
        columns={[
          {
            title: "应用名称",
            dataIndex: "name",
            width: 200,
          },
          {
            title: "应用appkey",
            width: 320,
            dataIndex: "key",
          },
          {
            title: "登录账号",
            dataIndex: "account",
          },
          {
            title: "授权回调地址",
            dataIndex: "backEndUrl",
          },
          {
            title: "前端重定向地址",
            dataIndex: "frontEndUrl",
          },
          {
            title: "操作",
            align: "center",
            width: 160,
            render: (_, app) => {
              return (
                <Space>
                  <Button
                    shape="round"
                    type="primary"
                    size="small"
                    onClick={() => {
                      AuthStore.linkToSubsystem(app.key)
                      // window.open(`/sso/pass?appkey=${app.key}`, "blank");
                    }}
                  >
                    访问
                  </Button>
                  <Button
                    shape="round"
                    type="primary"
                    size="small"
                    onClick={() => {
                      props.onEdit(app.id);
                    }}
                  >
                    编辑
                  </Button>
                  <Button
                    shape="round"
                    type="primary"
                    size="small"
                    onClick={() => {
                      props.onDescribe(app.id);
                      ProjectStore.getDetails(app.key);
                    }}
                  >
                    填写描述
                  </Button>

                  <Popconfirm
                    cancelText="取消"
                    okText="确认"
                    title="是否删除该应用"
                    onConfirm={() =>
                      ProjectStore.removeApplication(app.id, app.key)
                    }
                  >
                    <Button
                      type="primary"
                      shape="round"
                      size="small"
                      danger={true}
                    >
                      删除
                    </Button>
                  </Popconfirm>
                </Space>
              );
            },
          },
        ]}
      />
    </div>
  );
};

export default Applications;
